export default __webpack_public_path__ + "static/media/StudioChair@2x.fd7b75b7.jpg";